/** @jsx jsx */

import { jsx, css } from "@emotion/react"
import { Fragment, useEffect, useState } from "react"
import { Props } from "../pages/kennis"
import { breakpoints, colors } from "@src/style"
import BubbleChart from "@weknow/react-bubble-chart-d3"
import { Section } from "./section"
import { Body, H4 } from "./typography"
import { IoMdClose } from "react-icons/io"

export const KennisBubblesModule: React.FC<Props> = ({ data }) => {
  const [windowSize, setWindowSize] = useState<{
    width: number
    height: number
  } | null>(null)
  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      })
    }
    window.addEventListener("resize", handleResize)

    handleResize()

    return () => window.removeEventListener("resize", handleResize)
  }, [])
  const [loaded, setLoaded] = useState(false)
  useEffect(() => {
    const timeout = setTimeout(() => setLoaded(true), 500)
    return () => clearTimeout(timeout)
  }, [])

  const dataCategories = data.datoCmsKennisPage.categories
  const [categories, setCategories] = useState(
    dataCategories.map(category => ({ ...category, random: Math.random() }))
  )
  const [selectedCategory, setSelectedCategory] = useState<any>(null)
  return (
    <Fragment>
      <Section
        background="gold"
        css={css`
          display: flex;
          justify-content: center;
          position: relative;
          circle,
          text {
            cursor: pointer;
            text-transform: uppercase;
          }
        `}
      >
        <BubbleChart
          graph={{
            zoom: windowSize
              ? windowSize.width < breakpoints.desktop
                ? 1.0
                : 0.78
              : 0.8,
            offsetX: windowSize
              ? windowSize.width < breakpoints.desktop
                ? -0.1
                : 0.07
              : 0.07,
            offsetY: windowSize
              ? windowSize.width < breakpoints.desktop
                ? -0.4
                : -0.1
              : -0.0,
          }}
          width={windowSize ? windowSize.width * 0.5 : 320}
          height={
            windowSize
              ? windowSize.width < breakpoints.desktop
                ? windowSize.width * 0.2
                : windowSize.width * 0.32
              : 320
          }
          padding={20} // optional value, number that set the padding between bubbles
          showLegend={false} // optional value, pass false to disable the legend.
          valueFont={{
            size: 0,
          }}
          overflow={true}
          labelFont={{
            family: "Snv Cond D Fixed",
            size: windowSize
              ? windowSize.width < breakpoints.desktop
                ? 10
                : 30
              : 30,
            weight: "normal",
            color: colors.white,
          }}
          //Custom bubble/legend click functions such as searching using the label, redirecting to other page
          bubbleClickFun={(label: string) => {
            setSelectedCategory(
              categories.filter(category => category.title === label)[0]
            )
          }}
          data={categories.map(category => ({
            label: category.title,
            value: category.count,
            color:
              category.random < 0.33
                ? colors.white
                : category.random < 0.66
                ? colors.black
                : colors.red,
            textColor: category.random < 0.33 ? colors.black : colors.white,
          }))}
        />
      </Section>
      {loaded && <div></div>}
      {selectedCategory && (
        <div
          css={css`
            background-color: rgba(100, 100, 100, 0.2);
            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 9999;
            display: flex;
            justify-content: center;
            align-items: center;
          `}
          onClick={() => setSelectedCategory(null)}
        >
          <div
            css={css`
              background-color: ${colors.black};
              padding: 60px 60px;
              color: ${colors.white};
              width: 90%;
              max-width: 500px;
              position: relative;
            `}
            onClick={e => e.stopPropagation()}
          >
            <IoMdClose
              css={css`
                position: absolute;
                top: 8px;
                right: 8px;
                font-size: 28px;
                cursor: pointer;
              `}
              onClick={() => setSelectedCategory(null)}
            />
            <H4
              css={css`
                margin-bottom: 24px;
              `}
            >
              {selectedCategory.title}
            </H4>
            <Body
              dangerouslySetInnerHTML={{
                __html:
                  selectedCategory.descriptionNode.childMarkdownRemark.html,
              }}
            />
          </div>
        </div>
      )}
    </Fragment>
  )
}
